"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_jss_1 = require("react-jss");
var styles = (0, react_jss_1.createUseStyles)(function (theme) { return ({
    wrapper: {
        width: '100%',
        display: 'grid',
        gap: theme.spacing.small
    }
}); });
exports.default = styles;
//# sourceMappingURL=AccordionGroup.styles.js.map